var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonLogoFitgenieInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 144 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "common_logo_fitgenie_inverted_svg__a",
    d: "M.012.167h93.573v27.608H.012z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "common_logo_fitgenie_inverted_svg__c",
    d: "M0 0h100.403v31.705H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_inverted_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_inverted_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#common_logo_fitgenie_inverted_svg__b)",
    d: "M3.64 3.844v8.696h11.624v3.371H3.64V27.29H0V.473h16.995v3.371H3.64M20.576 27.289h3.405V8.135h-3.405v19.154zm-.587-24.862c0-1.226 1.017-2.26 2.309-2.26a2.28 2.28 0 012.27 2.26c0 1.226-1.018 2.222-2.27 2.222-1.292 0-2.31-.996-2.31-2.222zM34.352 11.353v10.382c0 2.911 1.722 2.72 5.205 2.566v2.988c-5.87.766-8.61-.766-8.61-5.554V11.353h-3.874V8.269h2.781c.604 0 1.093-.48 1.093-1.07V3.768l3.405-.996v5.363h5.205v3.218h-5.205M77.069 16.333h13.072c-.587-3.793-3.366-5.555-6.301-5.555-3.679 0-6.223 2.222-6.771 5.555zm7.084 8.313c2.7 0 4.657-1.226 5.636-2.797l2.896 1.61c-1.722 2.604-4.696 4.328-8.61 4.328-6.302 0-10.49-4.329-10.49-10.075 0-5.67 4.15-10.075 10.255-10.075 5.91 0 9.745 4.75 9.745 10.113 0 .498-.039.996-.117 1.494H77.069c.666 3.448 3.444 5.402 7.084 5.402z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.939 .04)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "common_logo_fitgenie_inverted_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#common_logo_fitgenie_inverted_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.203 31.211h3.394V11.753h-3.394v19.458zm-.585-25.257a2.303 2.303 0 012.302-2.296c1.248 0 2.263 1.051 2.263 2.296a2.262 2.262 0 01-2.263 2.258c-1.288 0-2.302-1.012-2.302-2.258zM83.94 20.081h13.03c-.585-3.853-3.355-5.643-6.281-5.643-3.667 0-6.203 2.257-6.75 5.643zM91 28.526c2.692 0 4.643-1.245 5.618-2.84l2.887 1.634c-1.717 2.646-4.682 4.397-8.583 4.397-6.281 0-10.456-4.397-10.456-10.235 0-5.76 4.136-10.235 10.222-10.235 5.89 0 9.714 4.826 9.714 10.274a9.97 9.97 0 01-.117 1.518H83.94c.664 3.503 3.434 5.487 7.062 5.487z",
    fill: "#FFF",
    mask: "url(#common_logo_fitgenie_inverted_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.192 13.79a12.053 12.053 0 00-6.912-6.895A12.053 12.053 0 0024.192 0a12.053 12.053 0 006.912 6.895 12.054 12.054 0 00-6.912 6.895",
    fill: "#1EAD5E",
    mask: "url(#common_logo_fitgenie_inverted_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.331 17.238H13.767v3.448h10.655c-1.337 4.384-5.426 7.584-10.252 7.584-5.908 0-10.714-4.795-10.714-10.687 0-5.778 4.62-10.496 10.368-10.68V3.457C6.171 3.641 0 9.904 0 17.583c0 7.793 6.357 14.134 14.17 14.134s14.17-6.34 14.17-14.134c0-.116-.006-.23-.009-.345M70.628 18.847v11.878h-3.326V19.04c0-3.173-1.797-4.953-4.74-4.953-3.059 0-5.544 1.819-5.544 6.384v10.253h-3.326V11.38h3.326v2.786c1.415-2.283 3.517-3.29 6.193-3.29 4.473 0 7.417 3.019 7.417 7.971",
    fill: "#FFF",
    mask: "url(#common_logo_fitgenie_inverted_svg__d)"
  })))));
}

export default SvgCommonLogoFitgenieInverted;